module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The River Below")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapter-number"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "flush-left-opener"
  }, [_vm._v("After sixteen years, Laura Dail is still the one person whose knowledge and skill I trust without question, and I am lucky to have her as my literary agent. I am grateful to Martha Conway and her University of California, Berkeley Extension class, where I began the story that became this book. Over the three-year period I worked on the novel, I received help and inspiration from many and sometimes, I felt, from the river itself. Thanks to my husband, Larry, who encouraged me to finish the book; to my Hanford lunch group, whose support is strong after all these years; to environmental scientist Wendy Cooper, who helped me imagine Claire’s job; and to my inspirational friends, Cynthia and Thane Murphy.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("This book is set at and near the San Joaquin River, and for the sake of the story, I have also created a fictional river conservancy group housed first at the river and then at the university. The group has nothing in common with the very real San Joaquin River Parkway and Conservation Trust, of which I am a member. I have also changed some of the geography to aid the plot.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("Thanks to the members of my literary family – Jen Badasci, Annie and John Brantingham, Hazel Dixon-Cooper, Christopher Allan Poe and Stacy Lucas – who kindly fillet my work on a weekly basis and whose input helped shape the book. I am especially grateful to Hazel, who has spent hours with me on the banks of the San Joaquin River, through every season, looking out at the water as we ask each other, ‘What if?’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7d8ba1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter000.vue
// module id = 75
// module chunks = 0